import { useAuth } from '../AuthProvider';
import type { TourActionTriggerSource } from '../constants/clickstreamEvents/tourScheduling';
import {
  emitInboxTourActionEvent,
  emitLeadMgmtTourActionEvent,
  INBOX_TOUR_ACTION_EVENT_TYPE_ID,
  LEAD_MGMT_TOUR_ACTION_EVENT_TYPE_ID,
} from '../constants/clickstreamEvents/tourScheduling';
import { PAGE_NAME } from '../constants/pageName';
import usePageIdentifier from './usePageIdentifier';

/** Tour action clickstream for the current page: the event id for `data-eventid` and an emitter. */
export default function useTourActionClickstream({
  leadId,
  listingAlias,
}: {
  leadId?: string | null;
  listingAlias: string;
}) {
  const { user } = useAuth();
  const currentPage = usePageIdentifier();

  const eventTypeId =
    currentPage === PAGE_NAME.leadManagement ? LEAD_MGMT_TOUR_ACTION_EVENT_TYPE_ID : INBOX_TOUR_ACTION_EVENT_TYPE_ID;

  const fireTourActionEvent = (triggerSource: TourActionTriggerSource) => {
    if (currentPage === PAGE_NAME.leadManagement) {
      emitLeadMgmtTourActionEvent({ user, listing: { listingAlias }, triggerSource, lead: { leadId } });
    } else if (currentPage === PAGE_NAME.inbox) {
      emitInboxTourActionEvent(user, triggerSource, { listingAlias });
    }
  };

  return { eventTypeId, fireTourActionEvent };
}
